import {
	SET_FORM_STATE,
} from '../actions/BwUpdateActions.js';

const initialState = {
	operators: [],
	openAddOperatorDialog: false,
	detailsOperatorId: null,
	operator: {},
	formState: {
		bwUpdate: {
			isValid: false,
			values: {},
			touched: {},
			errors: {},
		}
	},
	openAddProjectDialog: false,
	templates: [],
};

const bwUpdateReducer = (state = initialState, action) => {
	switch (action.type) {
					case SET_FORM_STATE: {
						return {
							...state,
							formState: { ...state.formState, ...action.formState }
						};
					}
					default: {
						return state;
					}
	}
};

export default bwUpdateReducer;
